import * as UUID from 'uuid'
import Cookie from 'js-cookie'

const key = 'UNIQUEID';

export default () => {
  const exist = Cookie.get(key);
  if(exist) {
    return exist;
  }
  const generated = UUID.v4();
  Cookie.set(key, generated);
  return generated;
}
